/* Use to manage API changes */

import axios from "@/axios";

/**
 * @typedef {Object} SectionData payload from the FormBuilder
 * @property {Object} data
 * 
 * @param {SectionData} data 
 * @returns {SectionData[]} formatted payload
 */
export const sortByOrderArr = ({ orderArray, arr, keyName }) => {
	const orderMap = new Map(orderArray.map((key, index) => [key, index]));
	return [...arr].sort((a, b) => orderMap.get(a[keyName]) - orderMap.get(b[keyName]));
};

export const formatSections = (data) => {
	return { sections: [data.data] };
};

export const formatDuplicateSections = (data) => {
	let details = []
	data.forEach(el => {
		details.push(el.data)
	})
	return {sections: details};
};

export const fetchEntityFormList = async ({
	case_id,
	entity_id, // case entity id
}, case_creation = true) => {
	const { data } = await axios(
		`case/${case_id}/${entity_id}/forms`,
		{
			params: {
				case_creation,
			},
		}
	);

	return data;
};

export const fetchEntityForm = async ({
	case_id,
	entity_id,
}, params = {}) => {
	const { data } = await axios(
		`case/${case_id}/entity/${entity_id}/case-entity-creation-form-v2`,
		{
			params,
		}
	);

	return data;
};

/**
 * @typedef {Object} SaveFormPayload
 * @property {String} case_id
 * @property {String} entity_id
 * @property {SectionData} data payload from the FormBuilder
 * 
 * @param {SaveFormPayload} payload 
 * @returns {Boolean} flag if form has been saved
 */
export const saveEntityFormSection = async ({
	case_id,
	entity_id,
	data,
}) => {
	let sectionSaved = false;
	await axios.post(
		`case/${case_id}/entity/${entity_id}/case-entity-creation-form`,
		formatSections(data)
	);
	sectionSaved = true;

	return sectionSaved;
};

export const getDuplicateEntities = async ({
	case_id,
	entity_id,
	data,
}) => {
	// let sectionSaved = false;
	let response = await axios.post(
		`case/form/${case_id}/entity/${entity_id}/duplicate-entities`,
		formatDuplicateSections(data)
	);

	return response.data;
};

/**
 * Submit particular entity form
 */
export const submitEntityForm = async ({
	case_id,
	entity_id,
	tenant_check_id,
}) => {
	await axios.post(
		`case/${case_id}/entity/${entity_id}/creation/tenant-form/submit`,
		{},
		{
			params: {
				tenant_check_id,
			},
		}
	);
};

export const submitRedirectionForm = async (prefix, {
	case_id,
	entity_id,
	form_id,
}) => {
	await axios.post(`/case${prefix}/${case_id}/entity/${entity_id}/form/${form_id}/submit`);
};

export const submitUIRedirectionForm = async (payload) => {
  await axios.post(`case/ui-redirection-form-submitted`, payload);
};

/**
 * Final submit of the whole entity form list
 */
export const submitEntityFormList = async ({
	case_id,
	entity_id,
	is_duplicate,
}) => {
	let payload = {
		is_duplicate: is_duplicate
	}
	await axios.post(
		`case/${case_id}/entity/${entity_id}/case-entity-creation-form/submit`,payload
	);
};

const entityFormAPI = {
	fetchEntityFormList,
	fetchEntityForm,
	saveEntityFormSection,
	getDuplicateEntities,
	submitEntityForm,
	submitRedirectionForm,
	submitUIRedirectionForm,
	submitEntityFormList,
	formatSections,
	formatDuplicateSections,
	sortByOrderArr,
}

export default entityFormAPI;
